import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AgmModule } from '../../shared/models/agm.module';
import { TranslationModule } from '../../shared/models/translation.module';
import { SharedModule } from '../../shared/shared.module';
import { ConstructionInformationComponent } from './construction-information.component';
import { SignatureComponent } from './signature/signature.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,

    SharedModule,
    TranslationModule,
    AgmModule
  ],
  declarations: [
    SignatureComponent,
    ConstructionInformationComponent
  ]
})
export class ConstructionInformationModule {

}